import { CARRIER_COORDINATION as T } from "@/constants/testIds";
import { Handshake, MailX, Gauge, Eye, LayoutGrid, Boxes } from "lucide-react";

const outcomes = [
  { icon: Handshake, title: "Better Carrier Coordination", detail: "Every carrier interaction — from freight booking to sailing confirmation — happens in one structured Workspace." },
  { icon: MailX, title: "Fewer Emails", detail: "Replace status-check threads with a shared shipment timeline your team and carriers can trust." },
  { icon: Gauge, title: "Faster Booking Decisions", detail: "Compare carrier options, confirm bookings and lock schedules without switching tools." },
  { icon: Eye, title: "Improved Shipment Visibility", detail: "Container status, ETAs and documentation live in one view — updated in real time." },
  { icon: LayoutGrid, title: "Centralized Operations", detail: "Consolidate carrier coordination, booking management and export logistics inside a single system." },
  { icon: Boxes, title: "One Workspace", detail: "FreightIQ™ connects seamlessly with the rest of your DeMaxtore Workspace — no more tool sprawl." },
];

export default function Outcomes() {
  return (
    <section id="outcomes" data-testid={T.outcomes} className="relative bg-[#fafbfd] py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mx-auto max-w-3xl">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-brand">Business Outcomes</p>
          <h2 className="mt-4 text-3xl font-semibold text-navy sm:text-4xl lg:text-[44px] lg:leading-[1.08]">
            Outcomes That Move The Business
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-slate-600">
            Enterprise import teams choose FreightIQ™ because carrier coordination becomes a lever — not a bottleneck.
          </p>
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {outcomes.map(({ icon: Icon, title, detail }, i) => (
            <article
              key={title}
              className={`animate-fade-up group relative rounded-2xl border border-slate-line bg-white p-7 transition hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-card-lg stagger-${(i % 6) + 1}`}
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-soft text-blue-brand">
                  <Icon className="h-5 w-5" strokeWidth={1.8} />
                </span>
                <span className="font-mono text-[11px] text-slate-400">0{i + 1}</span>
              </div>
              <h3 className="mt-6 text-lg font-semibold text-navy">{title}</h3>
              <p className="mt-2.5 text-[14px] leading-relaxed text-slate-600">{detail}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
